import { AgencyContextPreview } from '@apps/web/components/phoebe_chat_view/artifacts/record_preview/agency_context_preview';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@apps/web/components/ui/dialog';

/** Everything Phoebe holds about how this agency runs, opened in place. */
export function AgencyContextModal({
    organizationId,
    fallbackText,
    onClose,
}: {
    readonly organizationId: string;
    readonly fallbackText: string;
    readonly onClose: () => void;
}) {
    return (
        <Dialog
            open={true}
            onOpenChange={(next) => {
                if (!next) {
                    onClose();
                }
            }}
        >
            <DialogContent className="max-h-[80vh] overflow-y-auto sm:max-w-xl">
                <DialogHeader>
                    <DialogTitle>Agency details</DialogTitle>
                    <DialogDescription>
                        How Phoebe understands this agency runs.
                    </DialogDescription>
                </DialogHeader>
                <AgencyContextPreview
                    organizationId={organizationId}
                    fallbackText={fallbackText}
                />
            </DialogContent>
        </Dialog>
    );
}
